<clp-toolbar [title]="('category.title' | translate)">
    <a [routerLink] = "['/createCategory']" routerLinkActive="activeClass" class="clp-btn clp-btn-warning clp-btn-sm">{{'general.create' | translate}}</a>
</clp-toolbar>

<div class="mt-4">
    @if (categories$ | async; as categories) {
        @if (categories.length > 0) {
        <div class="overflow-x-auto">
        <table class="clp-table clp-table-striped clp-table-hover clp-table-sm">
            <thead class="text-left">
                <tr>
                    <th></th>
                    <th>{{'category.name' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                @for (category of categories$ | async; track $index) {
                    <tr>
                        <td>
                            <button class="clp-btn clp-btn-warning clp-btn-sm mr-1" (click)="editCategory(category.id)" ><i class="fa-regular fa-pen-to-square"></i></button>
                            <button class="clp-btn clp-btn-warning clp-btn-sm" (click)="deleteCategory(category.id)" ><i class="fa-solid fa-trash-can"></i></button>
                        </td>
                        <td class="w-full">{{category.name}}</td>
                    </tr>        
                }
            </tbody>
        </table>
        </div>
        }
    }
</div>
